import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function initDevOpsPipeline(): void {
    const steps = document.querySelectorAll('.pipeline-step');
    if (steps.length === 0) return;

    // Moving light pulse through pipeline
    const tl = gsap.timeline({ repeat: -1 });
    steps.forEach((step) => {
        tl.to(step, { 
            borderColor: '#ff00ff', 
            backgroundColor: 'rgba(255, 0, 255, 0.15)',
            duration: 0.4 
        })
        .to(step, { 
            borderColor: 'rgba(255, 255, 255, 0.06)', 
            backgroundColor: 'transparent',
            duration: 0.4 
        });
    });
}
